'use strict';

require('./categories/CompanyCategoryService.js');
require('./CompanyService.js');
require('./CompanyInfoService.js');
require('./groups/CompanyGroupService.js');
require('./publications/CompanyPublicationService.js');
require('./users/CompanyUserService.js');
require('./tasks/CompanyTaskNewCtrl.js');
require('./CompanyAdvancedSearchDirective.js');
require('./comments/CompanyCommentsService.js');
require('./publications/CompanyUserLinksCtrl.js');
require('./user-roles/CompanyUserRoleService.js');
require('./checklist/CompanyChecklistService.js');
require('./tasks/CompanyTaskDetailCtrl.js');

var deviationCategory = [
    {
        "category": "OLYCKA",
        "color": 0,
        "description": ""
    },
    {
        "category": "FORBATTRINGAR",
        "color": 0,
        "description": ""
    },
    {
        "category": "REKLAMATIONER",
        "color": 0,
        "description": ""
    },
    {
        "category": "TILLBUD",
        "color": 0,
        "description": ""
    },
    {
        "category": "AVVIKELSE",
        "color": 0,
        "description": ""
    },
    {
        "category": "KUND_ARENDEN",
        "color": 0,
        "description": ""
    },
    {
        "category": "EKONOMI",
        "color": 0,
        "description": ""
    },
    {
        "category": "LEVERANTORS_ARENDEN",
        "color": 0,
        "description": ""
    },
    {
        "category": "KUND",
        "color": 0,
        "description": ""
    },
    {
        "category": "LEVERANTOR",
        "color": 0,
        "description": ""
    },
    {
        "category": "MILJO",
        "color": 0,
        "description": ""
    },
    {
        "category": "OLYCKS_PERSON_SKADA",
        "color": 0,
        "description": ""
    },
    {
        "category": "ARBETSMIL_RISK_OLYCKS_RISK",
        "color": 0,
        "description": ""
    }
  ];

function CompanyCtrl(
  $scope,
  $rootScope,
  stateSnapshot,
  publicationTypes,
  categories,
  groups,
  tags,
  customerPortals,
  currentUserPermissions,
  currentUser,
  userInformation,
  role,
  translations,
  $state,
  $stateParams,
  $timeout,
  $translate,
  $filter,
  uploadTracker,
  $q,
  $modal,
  $window,
  growl,
  config,
  company,
  CompanyCategoryService,
  CompanyService,
  CompanyPublicationService,
  CompanyCommentsService,
  CompanyInfoService,
  CompanyUserService,
  info,
  notices,
  CompanyChecklistService
) {
  if (userInformation && userInformation.features && userInformation.features.denyLoginOnWeb) {
    $state.go('root.company.403', {}, { location: false });
  }
  $scope.isHideComment = userInformation.hide_comments || false;
  $scope.publicationQuery = {
    q: '',
    qType: 'GENERAL',
    groupId: '',
    categoryId: '',
    tags: [],
    page: 0,
    priorityId: null,
    type: null,
    from: null,
    to: null,
    orderby: 'created'
  };

  $scope.info = info;
  

  if(!info.extra.deviationCategory){
    $scope.info.extra.deviationCategory = deviationCategory;
  }else{
    $scope.info.extra.deviationCategory = 
      $scope.info.extra.deviationCategory.filter(function(dC){
        return $scope.info.extra.deviationCategory.some(function(c){
                return dC.category===c.category
              })
      }).concat(
        deviationCategory.filter(function(dC){
          return !$scope.info.extra.deviationCategory.some(function(c){
                  return dC.category===c.category
                })
        })
      );
  }
  $scope.$on('companyInfoChanged', function(){
    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise.then(function(resp){
      $scope.info = resp;
    });
  });

  $scope.$on('eventModifyPermissions', function(e, data) {
    $scope.$apply(function() {
      $scope.currentUserPermissions = data;
    });
    
  });
  
  $scope.company = company;
  $scope.categoryActive = false;
  $scope.categories = categories;
  $scope.groups = groups;
  $scope.tags = tags;
  $scope.userType = $stateParams.userType;
  $scope.currentUserPermissions = currentUserPermissions;
  $scope.state = $state;
  $scope.userInfo = userInformation;
  $scope.apiBase = config.apiBase;
  $scope.portalUrl = config.portalUrl
  $scope.currency = 'sek';
  $scope.showAll = $stateParams.showAll || false;
  $scope.currentType = $stateParams.type;
  $scope.toggleMenuSearch = true;

  if(userInformation && !userInformation.features.selectedRole){
      if(userInformation.roles !== null && userInformation.roles[0]){
        $scope.userInfo.features.selectedRole = userInformation.roles[0];
      }
  }

  $scope.changetoggleMenuSearch = function(){
    $scope.toggleMenuSearch = !$scope.toggleMenuSearch;
  };

  function checkHasSubMenu() {
    if ($scope.role !== null || ($scope.role && $scope.role.template !== null)) {
      angular.forEach($scope.role.menus, function(v){
        var hasSub = $scope.role.menus.some(function(m){
          return m.parentId === v.id;
        });

        if (hasSub) {
          v.hasSub = true;
        }
      });
    }
  }

  $scope.role = role;
  $scope.$on('roleChanged', function(event, data) {
    $scope.role = angular.copy(data);
    checkHasSubMenu();
  });
  checkHasSubMenu();

  $scope.notices = notices;
  $scope.types = publicationTypes;
  $scope.customerPortals = customerPortals;

  function checkPermissionGroup(group) {
    if (!group) {
      group = [];
    }
    if (group.length === 0) {
      return true;
    }

    var matched = false;
    angular.forEach(group, function(val){
      if (!matched) {
        matched = $scope.groups.some(function(g){
          return g.id === val.id;
        });
      }
    });
    return matched;
  }

  if ($scope.role && $scope.role.template !== undefined) {
    angular.forEach($scope.role.links, function(v){
      v.show = true;
      if (v.link.indexOf(config.appBase) !== -1) {
        if (!angular.isArray(v.groups)) {
          v.group = [];
        }
        if (!checkPermissionGroup(v.groups)) {
          v.show = false;
        }
      }
    });
  }

  var modal;
  $scope.showTaskModal = function(publication, data) {
    modal = $modal({
      scope: $scope,
      controller: 'CompanyTaskNewCtrl',
      templateUrl: 'partials/company/tasks/modal-new.html',
      show: false,
      resolve: {
        publication: function() {
          return publication || false;
        },
        taskTypes: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
          return CompanyService.queryTaskTypes({companyId: $stateParams.companyId}).$promise;
        }],
        data: function() { return data; }
      }
    });
    modal.$promise.then(modal.show);
  };

  $scope.showTaskDetailModal = function(task) {
    $rootScope.loading = true;
    modal = $modal({
      scope: $scope,
      controller: 'CompanyTaskDetailCtrl',
      templateUrl: 'partials/company/tasks/modal-detail.html',
      show: false,
      resolve: {
        task: function() {
          return task;
        },
        taskTypes: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
          return CompanyService.queryTaskTypes({companyId: $stateParams.companyId}).$promise;
        }],
        checklists: function() {
          return CompanyChecklistService.query({
            companyId: $stateParams.companyId,
            relativeID: task.id
          }).$promise;
        }
      }
    });

    modal.$promise.then(function(){
      modal.show();
      $rootScope.loading = false;
    });
  };

  $scope.showModalCustomer = function(stt, order100) {
    $rootScope.loading = true;
    modal = $modal({
      scope: $scope,
      controller: 'CompanyCustomerNewPopupCtrl',
      templateUrl: 'partials/company/customers-dashboard/new.html',
      show: false,
      resolve: {
        order100: function(){
          return order100 || false;
        },
        status: function() {
          return stt || false;
        },
        customerStatuses: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
          return CompanyService.queryCustomerStatus({companyId: $stateParams.companyId}).$promise;
        }],
        customerCategories: ['$stateParams', 'CompanyCustomerCategoriesService', function($stateParams, CompanyCustomerCategoriesService) {
          return CompanyCustomerCategoriesService.query({
            companyId: $stateParams.companyId,
            type: 'CATEGORY',
            limit: 1000
          }).$promise;
        }],
        customerTypes: ['$stateParams', 'CompanyCustomerCategoriesService', function($stateParams, CompanyCustomerCategoriesService) {
          return CompanyCustomerCategoriesService.query({
            companyId: $stateParams.companyId,
            type: 'TYPE',
            limit: 1000
          }).$promise;
        }],
        priceLists: ['$stateParams', 'CompanyProductsService', function($stateParams, CompanyProductsService) {
          if(info.features.products){
            return CompanyProductsService.priceListQuery({companyId: $stateParams.companyId, limit: 1000}).$promise;
          }
          return false;
        }]
      }
    });
    modal.$promise.then(function(){
      modal.show();
      $rootScope.loading = false;
    });
  };

  $scope.$on('customerCreated', function(evt, resp){
    $scope.$broadcast('customerOrder100', resp);
  });

  $scope.$on('modal.hide', function(){
    if (typeof modal === 'object') {
      modal.destroy();
      modal = null;
    }
  });

  $scope.toggleTag = function(tag) {
    if (-1 === $scope.publicationQuery.tags.indexOf(tag)) {
      $scope.publicationQuery.tags.push(tag);
    } else {
      $scope.publicationQuery.tags.splice($scope.publicationQuery.tags.indexOf(tag), 1);
    }
  };

  $scope.currentCompany = company;

  $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
    var attr;
    for (attr in $scope.publicationQuery) {
      if($scope.publicationQuery.hasOwnProperty(attr)) {
        if('tags' === attr) {
          if(!toParams[attr]) {
            $scope.publicationQuery[attr] = [];
            continue;
          }

          if(!Array.isArray(toParams[attr])) {
            $scope.publicationQuery[attr] = toParams[attr].split(',');
          }
          else  {
            $scope.publicationQuery[attr] = toParams[attr];
          }
        } else {
          $scope.publicationQuery[attr] = toParams[attr];
        }
      }
    }

  });

  $scope.$parent.companyId = company.id;

  $scope.$on('categoriesChanged', function(ev, categories) {
    if(categories) {
      $scope.categories = categories;
    } else {
      CompanyCategoryService.query({companyId: company.id}, function(categories) {
        $scope.categories = categories;
      });
    }
  });

  var reloadTagsTimeout;
  $scope.$on('tagsChanged', function() {
    if(reloadTagsTimeout) {
      $timeout.cancel(reloadTagsTimeout);
      reloadTagsTimeout = null;
    }
    reloadTagsTimeout = $timeout(function() {
      CompanyService.queryTags({companyId: company.id}, function(tags) {
        $scope.tags = tags;
      });
    }, 1000 * 61);
  });

  var searchTimeout;
  $scope.filterPublications = function(url) {

    if(!url) {
      url = 'root.company.publications-list';
    }
    if(searchTimeout){
      $timeout.cancel(searchTimeout);
      searchTimeout = null;
    }
    searchTimeout = $timeout(function () {
      var q = angular.copy($scope.publicationQuery);

      // Remove tags from query string if it is empty
      if(q.tags) {
        if(q.tags.length === 0) {
          q.tags = null;
        } else {
          q.tags = q.tags.join(',');
        }
      }
      if(q.tags && 0 === q.tags.length) {
        q.tags = null;
      }
      $state.go(url, q);
      searchTimeout = null;
    }, 200);
  };

  $scope.filterStatus = function(priority, url) {
    $scope.publicationQuery.priorityId = priority.id;
    $scope.filterPublications(url);
  };

  /* FIXME: Transform to directive */
  $scope.getPublicationIcon = function(type) {
    switch(type) {
      case 'DEFAULT':                        return 'fa-files-o';
      case 'FOLDER':                         return 'fa-briefcase';
      case 'ALBUM':                          return 'fa-image';
      case 'FORM':                           return 'fa-clipboard';
      case 'NOTE':                           return 'fa-file-text-o';
      case 'KEYPASS':                        return 'fa-key';
      case 'MASTERFILE':                     return 'fa-file-text';
      case 'WALL':                           return 'fa-comments-o';
      case 'PLANT':                          return 'fa-industry';
      case 'ORDER':                          return 'fa-list';
      case 'CUSTOMER_ADAPTION':              return 'fa-cogs';
      case 'ENGINE_MODEL':                   return 'fa-folder';
      case 'PUBLICATION_GROUP':              return 'fa-object-group';
      case 'COMPANY_ORDER':                  return 'fa-shopping-cart';
      case 'ORDER_SUBCRIPTION':              return 'fa-shopping-cart';
      case 'PUBLICATION_SPREAD_SHEET':       return 'fa-table';
      case 'BLOG':                           return 'fa-blog';
      case 'INVESTIGATION':                  return 'fa-investigation';
      case 'SK3_FOLDER':                     return 'fa-lock';
    }
  };

  /* FIXME: Move to service */
  $scope.setPublicationStatus = function(origPublication, s) {
    /* We need to make a clone here to prevent changes from
     * appearing too early in the interface.
     */
    var p = angular.copy(origPublication);

    p.status = s;

    p.$update({companyId: $stateParams.companyId, status: s},
      function() {
        growl.addSuccessMessage(translations['publication.save-success']);

        origPublication.status = s;
      },
      function(resp) {
        if (304 === resp.status) {
          return;
        }

        growl.addErrorMessage(translations['publication.save-failure'] + ': ' + resp.data.error.message);
      });
  };

  /* FIXME: Move to service */
  $scope.uploadFilesForPublication = function(files, publicationId) {
    return uploadTracker(files.map(function(f) {
      return {
        url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/" + publicationId + "/files",
        file: f,
      };
    }));
  };

  /* FIXME: Move to service or where it is used */
  $scope.getPublicationsByQuery = function(q) {
    if (q && q.length > 0) {
      return CompanyPublicationService.query({companyId: $stateParams.companyId, q: q}).$promise.then(function(publications) {
        return publications;
      });
    }
  };

  /* FIXME: Move to service */
  $scope.toggleUploadLock = function(publication) {
    if (publication.uploadLock) {
      CompanyPublicationService.unlockFileUpload({companyId: $stateParams.companyId, publicationId: publication.id}, function () {
        growl.addSuccessMessage(translations['publication.unlock-file-upload-success']);

        publication.uploadLock = null;
      }, function () {
        growl.addErrorMessage(translations['publication.unlock-file-upload-failure']);
      });
    }

    else {
      CompanyPublicationService.lockFileUpload({companyId: $stateParams.companyId, publicationId: publication.id}, {}, function () {
        growl.addSuccessMessage(translations['publication.lock-file-upload-success']);

        publication.uploadLock = {
          id: currentUser.id,
          name: currentUser.name,
          lockedAt: (new Date()).toISOString()
        };
      }, function () {
        growl.addErrorMessage(translations['publication.lock-file-upload-failure']);
      });
    }
  };

  /* FIXME: Move to service */
  $scope.savePublication = function(origPublication, tagsChanged) {
    var p = angular.copy(origPublication);

    // Format empty group value
    if(!p.groups[0]) {
      p.groups = [];
    }
    return p.$update({companyId: $stateParams.companyId},
      function() {
        if (tagsChanged) {
          $scope.$emit('tagsChanged');
        }
        growl.addSuccessMessage(translations['publication.save-success']);
        $scope.$broadcast('publicationSaved');
      },
      function(resp) {
        if (304 === resp.status) {
          $rootScope.sendUpdateEdit(true, currentUser, origPublication);
          return;
        }
        CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: origPublication.id}, function (publication) {
          origPublication = publication;
        });

        growl.addErrorMessage(translations['publication.save-failure'] + ': ' + resp.data.error.message);
      }
    );
  };

  /* FIXME: Move to service */
  $scope.removeTag = function(publication, tag) {
    publication.tags.splice(publication.tags.indexOf(tag), 1);

    return $scope.savePublication(publication, true);
  };

  /* FIXME: Move to service */
  $scope.addTagToPublication = function(publication, tag) {
    if(publication.tags.indexOf(tag) === -1) {
      publication.tags.push(tag);

      angular.element('#filterTags').val('');

      return $scope.savePublication(publication, true);
    }
  };

  $scope.$on('eventReloadDashboard', function(){
    if(stateSnapshot.previous.state.name === 'root.company.publications-list'){
      $state.go(stateSnapshot.previous.state.name, stateSnapshot.previous.params, {reload: true});
    }else{
      if($state.current.name === 'root.company.publications-list'){
        $state.reload();
      }else{
        window.localStorage.needToFetchDashboard = true;
      }
    }
  });

  $scope.openNewWindow = function(menu){
    if(!menu.mainMenu){
      if(menu.targetBlank){
        $window.open(menu.link, 'newwindow', 'width=1200, height=800');
      }else{
        $window.location.href = menu.link;
      }
    }
    return false;
  };

  $scope.showMoreMenu = function(){
    var widthUl = angular.element('#manyMenu').width();
    var widthLis = 0;
    var i = 1;
    angular.forEach(angular.element('#manyMenu > li'), function(ele){
      widthLis += angular.element(ele).width();
      if((widthLis + 29) > widthUl){
        angular.element(ele).css('display', 'none');
        angular.element('.menu-more').css('display', 'inherit');
      }else{
        angular.element(ele).css('display', 'inherit');
        angular.element('.menu-more').css('display', 'none');
        i++;
      }
    });
    angular.element('#manyMenu > li:nth-child('+i+')').css('display', 'none');
    var j = 1;
    angular.forEach(angular.element('#manyMenu > li.menu-more > ul > li'), function(ele){
      if(j < i){
        angular.element(ele).css('display', 'none');
      }else{
        angular.element(ele).css('display', 'inherit');
      }
      j++;
    });

    if(angular.element('.header__nav').hasClass('nested-nav__search-focus')){
      var widthWindowH = angular.element($window).width();
      if(widthWindowH > 807){
        var widthLogo = 253;
        if(widthWindowH < 999){
          widthLogo = 151;
        }
        angular.element('.header__nav').css('width', (widthWindowH-widthLogo)+'px');
        angular.element('.header__nav .header__search').css('width', (widthWindowH-widthLogo-59)+'px');
      }else{
        angular.element('.header__nav').css('width', 'inherit');
        angular.element('.header__nav .header__search').css('width', 'inherit');
      }
    }
  }

  setTimeout(function(){
    $scope.showMoreMenu();
  }, 50);

  angular.element($window).on('resize', function () {
    $scope.showMoreMenu();
  });
}

var isStandardCompanyState = /^root\.company(\..*|$)/i;

CompanyCtrl.resolve = {
  company: ['$stateParams', 'stateSnapshot', '$state', 'CompanyService', function($stateParams, stateSnapshot, $state, CompanyService) {
    return CompanyService.get({
      companyId: $stateParams.companyId,
      leaveCompany: stateSnapshot.previous.params.companyId || null
    }).$promise.then(function(company) {
      if(company.userType === "GUEST" && isStandardCompanyState.test(stateSnapshot.next.state.name)) {
        $state.go(stateSnapshot.next.state.name.replace(isStandardCompanyState, 'root.company-guest$1'), stateSnapshot.next.params);

        /* Required to prevent anything depending on company
           from actually sending XHRs. */
        throw new Error("Restarting routing");
      }

      return company;
    });
  }],
  categories: ['$stateParams', 'CompanyCategoryService', 'company', function($stateParams, CompanyCategoryService) {
    var page = parseInt($stateParams.pageCat, 10) || 1;

    return CompanyCategoryService.query({
      companyId: $stateParams.companyId,
      nonEmpty:  "true",
      limit:     21,
      offset:    (page - 1) * 20
    }).$promise;
  }],
  tags: ['$stateParams', 'CompanyService', 'company', function($stateParams, CompanyService) {
    return CompanyService.queryTags({companyId: $stateParams.companyId}).$promise;
  }],
  customerPortals: ['$stateParams', '$window', 'CompanyGroupService', function($stateParams, $window, CompanyGroupService) {
    return CompanyGroupService.query({companyId: $stateParams.companyId, userId: $window.localStorage.userId, type: 'VISIBLE', all: true}).$promise;
  }],
  currentUserPermissions: ['CurrentUserService', '$stateParams', function(CurrentUserService, $stateParams) {
    return CurrentUserService.getPermissions($stateParams.companyId);
  }],
  priorities: ['$stateParams', 'CompanyService', 'userInformation', function($stateParams, CompanyService, userInformation) {
    if(userInformation.type === 'DEFAULT'){
      return CompanyService.queryPriorities({companyId: $stateParams.companyId}).$promise;
    }
    return [];
  }],
  groups: ['$stateParams', '$window', 'CompanyGroupService', function ($stateParams, $window, CompanyGroupService) {
    return CompanyGroupService.query({
      companyId: $stateParams.companyId,
      userId: $window.localStorage.userId,
      type: null,
      all: true
    }).$promise;
  }],
  userInformation: ['$stateParams', 'CompanyUserService', '$window', function($stateParams, CompanyUserService, $window){
    return CompanyUserService.get({companyId: $stateParams.companyId, userId: $window.localStorage.userId}).$promise;
  }],
  info: ['$stateParams', 'CompanyInfoService', function($stateParams, CompanyInfoService) {
    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise;
  }],
  role: ['CompanyUserRoleService', '$stateParams', 'userInformation', 'info', function(CompanyUserRoleService, $stateParams, userInformation, info){
    var selectedRole = null;
    if(userInformation.features.selectedRole){
      selectedRole = userInformation.features.selectedRole;
    }else if(userInformation.roles !== null && userInformation.roles[0]){
      selectedRole = userInformation.roles[0];
    }
    if (info.features.userRole && selectedRole) {
      return CompanyUserRoleService.get({
        companyId: $stateParams.companyId,
        roleId: selectedRole.id
      }).$promise;
    }
    return null;
  }],
  notices: ['CompanyService', function(CompanyService){
    return CompanyService.queryNotices().$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.save-success',
      'publication.save-failure',
      'publication.lock-file-upload-success',
      'publication.lock-file-upload-failure',
      'publication.unlock-file-upload-success',
      'publication.unlock-file-upload-failure'
    ]);
  }]
};
module.exports = CompanyCtrl;

angular.module('dokiv')
  .controller('CompanyCtrl', [
    '$scope',
    '$rootScope',
    'stateSnapshot',
    'publicationTypes',
    'categories',
    'groups',
    'tags',
    'customerPortals',
    'currentUserPermissions',
    'currentUser',
    'userInformation',
    'role',
    'translations',
    '$state',
    '$stateParams',
    '$timeout',
    '$translate',
    '$filter',
    'UploadTracker',
    '$q',
    '$modal',
    '$window',
    'growl',
    'config',
    'company',
    'CompanyCategoryService',
    'CompanyService',
    'CompanyPublicationService',
    'CompanyCommentsService',
    'CompanyInfoService',
    'CompanyUserService',
    'info',
    'notices',
    'CompanyChecklistService',
    CompanyCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyCtrl.js
// module id = 57
// module chunks = 0